import {Grid} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import _ from "lodash";
import queryString from "query-string";
import React, {useEffect, useRef, useState} from "react";
import {toast} from "react-toastify";
import Abwasserbehandlung from "../../components/betriebsakte/anlagen/Abwasserbehandlung";
import AuslegungenPlanungFoerdermassnahmen from "../../components/betriebsakte/anlagen/AuslegungenPlanungFoerdermassnahmen";
import Bauwerke from "../../components/betriebsakte/anlagen/Bauwerke";
import Entlastung from "../../components/betriebsakte/anlagen/Entlastung";
import Entsorgungsraum from "../../components/betriebsakte/anlagen/entsorgungsraum/Entsorgungsraum";
import Foerdermassnahmen from "../../components/betriebsakte/anlagen/Foerdermassnahmen";
import Kanalnetz from "../../components/betriebsakte/anlagen/Kanalnetz";
import Kuehlwasser from "../../components/betriebsakte/anlagen/Kuehlwasser";
import StilllegenDialog from "../../components/betriebsakte/betrieb/StilllegenDialog";
import Zustaendigkeiten from "../../components/betriebsakte/common/Zustaendigkeiten";
import EABetriebsakteDatenContainer from "../../components/betriebsakte/EABetriebsakteDatenContainer";
import EABetriebsakteMainContainer from "../../components/betriebsakte/EABetriebsakteMainContainer";
import {useConfirmation} from "../../components/ConfirmationDialog/ConfirmationDialogProvider";
import EAButton from "../../components/EAButton";
import EAButtonBar from "../../components/EAButtonBar";
import EADialog from "../../components/EADialog";
import EATabs from "../../components/EATabs";
import AuditInfoDialog from "../../components/historie/AuditInfoDialog";
import EAHistorySelector from "../../components/historie/EAHistorySelector";
import {ABWASSERBEHANDLUNG, ENTLASTUNG, KANALNETZ, KUEHLWASSER} from "../../consts/anlagentyp";
import {AUSSERHALB_RLP, KOMMUNAL} from "../../consts/betriebstyp";
import {FACHOBJEKTSTATUS_GEPLANT, isFinalStatus} from "../../consts/fachobjektstatus";
import {BEAUFTRAGTER, BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBD} from "../../consts/funktionaleRollen";
import routes from "../../consts/routes.json";
import {createAnlageSchema, createInitialAnlage, createInitialAnlageSchema} from "../../initialObjects/AnlageObjects";
import {
    deleteAnlageAenderungsantrag,
    getAnlageEndpoint,
    getAnlageHasIndirekteinleiterEndpoint,
    getAnlageHistorie,
    getStammdatenAntragAnlageEndpoint,
    postAbwasserbehandlung,
    postAbwasserbehandlungAenderungsantrag,
    postEntlastung,
    postEntlastungAenderungsantrag,
    postKanalnetz,
    postKuehlwasser,
    postKuehlwasserAenderungsantrag,
    putAbwasserbehandlung,
    putEntlastung,
    putKanalnetz,
    putKuehlwasser,
} from "../../services/AnlagenService";
import {getBetriebEndpoint} from "../../services/BetriebeService";
import {getKuehlartEndpoint} from "../../services/WertelistenService";
import {handleApiException, useHttp} from "../../services/HttpService";
import {logger} from "../../services/LogService";
import {createCalculatedColumn, createColumn} from "../../utils/ColumnUtils";
import {useForm} from "../../utils/FormUtils";
import {changeFieldValueIfPresent} from "../../utils/ObjectUtils";
import {userHasAnyRole} from "../../utils/SecurityUtils";
import {useHttpSortById} from "../../utils/usePreformattedHttp";
import {ANLAGE_AUSSERHALB} from "../../consts/anlagenart";

function AnlagenDatenView(props) {
    const confirm = useConfirmation();
    const [currentVersion, setCurrentVersion] = useState(null);
    const tabAnlage = "Anlage";
    const tabAuslegung = "Auslegungs-/Planungsdaten";
    const tabAnlagenteile = "Anlagenteile";
    const tabEntsorgungsraum = "Entsorgungsraum";
    const tabZustaendigkeiten = "Zuständigkeiten";
    const [anlageId, setAnlageId] = useState();
    const readonly = !anlageId ? false : props.modus === "l";
    const {
        values,
        setValues,
        errors,
        setErrors,
        formFactory,
        validate,
        validateProperty,
        touchedValues,
        setTouchedValues,
        setSchema,
    } = useForm({readonly});
    const [selectedTab, setSelectedTab] = useState(tabAnlage);
    const urlRef = useRef({});
    const [kuehlartOptionen] = useHttpSortById(getKuehlartEndpoint);

    const {stammdatenAntrag: stammdatenAntragParam} = queryString.parse(props.location.search);

    const [stilllegenDialogOpen, setStilllegenDialogOpen] = useState(false);
    const [saveActionLoading, setSaveActionLoading] = useState(false);
    const [{loading: anlageLoading}, refetch] = useHttp(getAnlageEndpoint(anlageId), {manual: true});
    const [
        {data: hasIndirekteinleiter, loading: loadingHasIndirekteinleiter},
        fetchHasIndirekteinleiter,
    ] = useHttp(getAnlageHasIndirekteinleiterEndpoint(anlageId), {manual: true});
    const [parentAnlageLoader, refetchParentAnlage] = useHttp(getAnlageEndpoint(props.match.params.parentanlageid), {manual: true});
    const [betriebLoader, refetchBetrieb] = useHttp(getBetriebEndpoint(props.betriebsId), {manual: true});
    const [stammdatenAntragLoader, reFetchStammdatenAntrag] = useHttp(getStammdatenAntragAnlageEndpoint(anlageId), {
        manual: !anlageId || !userHasAnyRole([ZUST_SBD, SYSTEMADMIN, FACHADMIN]),
    });

    const {
        values: stammdatenantrag,
        setValues: setStammdatenantrag,
        errors: stammdatenErrors,
        setErrors: setStammdatenErrors,
        formFactory: innerFormFactory,
        validateDirectly: innerValidateDirectly,
    } = useForm({initialValues: {foerderungen: []}});
    const [dlgRequestChangeOpen, setDlgRequestChangeOpen] = useState(false);
    const [dlgApproveChangeOpen, setDlgApproveChangeOpen] = useState(false);

    // Historie
    const [auditInfoDialogOpen, setAuditInfoDialogOpen] = useState(false);
    const [auditInfoDialogViolation, setAuditInfoDialogViolation] = useState({art: "MISSING", faultyAuditInfo: {}});
    const [{data: historyData, loading: historyLoading}, refetchHistoryData] = useHttp(getAnlageHistorie(anlageId), {manual: !anlageId});

    useEffect(() => {
        const calcedId = isNaN(props.match.params.anlageid) ? null : parseInt(props.match.params.anlageid);
        if (calcedId !== anlageId) {
            setAnlageId(calcedId);
            return;
        }

        if (urlRef.current.location &&
            urlRef.current.location.search === props.location.search &&
            urlRef.current.location.pathname === props.location.pathname) {
            return; //Url hat sich nicht geändert. dementsprechend nichts ausführen
        }

        setSchema(createInitialAnlageSchema());

        if (!anlageId &&
            props.match.params.parentanlageid &&
            (!parentAnlageLoader.data || parentAnlageLoader.data.id !== parseInt(props.match.params.parentanlageid))) {
            refetchParentAnlage().catch((e) => handleApiException(e, "Error loading parentAnlage in Anlagendaten"));
        } else if (!anlageId && (!betriebLoader.data || betriebLoader.data.id !== parseInt(props.betriebsId))) {
            refetchBetrieb().catch((e) => handleApiException(e, "Error loading Betrieb in Anlagendaten"));
        }

        if (!anlageId && betriebLoader.data) {
            urlRef.current = {location: props.location};
            const objectToSet = createInitialAnlage(props.betriebstyp.id, props.location.search);
            setSchema(createAnlageSchema(props.betriebstyp.id, objectToSet));

            if (parentAnlageLoader.data) {
                objectToSet.aufnahme = {...parentAnlageLoader.data};
                objectToSet.aufnahme.value = objectToSet.aufnahme.bezeichnung;
            }

            objectToSet.zustaendigePersonen = [...betriebLoader.data.zustaendigePersonen].map((zustP) => {
                zustP.id = null;
                return zustP;
            });

            objectToSet.zustaendigeBearbeiter = [...betriebLoader.data.zustaendigeBearbeiter].map((zustB) => {
                zustB.id = null;
                return zustB;
            });

            setTouchedValues({});
            setErrors({});
            setValues(objectToSet);
        } else if (anlageId) {
            urlRef.current = {location: props.location};
            refetch().then(({data: valuesToSet}) => {
                logger.debug("Geladene Anlage", valuesToSet);
                setTouchedValues({});
                setErrors({});
                setValues(valuesToSet);
                setSchema(createAnlageSchema(props.betriebstyp.id, valuesToSet));
                if (currentVersion === null) setCurrentVersion(_.cloneDeep(valuesToSet));
            }).catch((e) => {
                handleApiException(e, "Error loading anlage");
            });
        }
    }, [
        props.match,
        props.betriebstyp.id,
        props.betriebsId,
        values,
        props.location,
        refetch,
        setValues,
        setTouchedValues,
        anlageId,
        betriebLoader.data,
        parentAnlageLoader.data,
        refetchBetrieb,
        refetchParentAnlage,
        currentVersion,
        setSchema,
        setErrors,
    ]);

    /**
     * Errors zurücksetzen wenn andere Anlage geöffnet wird oder neue Anlage erstellt wird
     */
    useEffect(() => {
        setErrors(null);
    }, [touchedValues, setErrors]);

    // Update Statuswechsel, falls Status gewechselt wird
    useEffect(() => {
        if (touchedValues.anlagenstatus && !touchedValues.statuswechsel) {
            if (touchedValues.anlagenstatus && isFinalStatus(values.anlagenstatus?.id)) {
                if (props.betriebstyp.id === KOMMUNAL && values.anlagenart?.id === ABWASSERBEHANDLUNG && !values.indirekteinleiter && !values.neueAufnahme) {
                    confirm({
                        title: "Anlage stilllegen",
                        description:
                            "Beim Stilllegen der Anlage müssen alle angeschlossenen Abwasseranlagen und der Entsorgungsraum neu zugeordnet werden!",
                        onSubmit: () => {
                            const newStatuswechselRequired = values.anlagenstatus?.id !== FACHOBJEKTSTATUS_GEPLANT;
                            values.statuswechsel = newStatuswechselRequired ? new Date() : null;
                            setValues(values);
                            setStilllegenDialogOpen(true);
                        },
                        onClose: () => {
                            values.anlagenstatus = {
                                id: "IN_BETRIEB",
                                value: "in Betrieb",
                            };
                            setValues(values);
                        }
                    });
                } else {
                    fetchHasIndirekteinleiter().catch((e) => handleApiException(e, "Error checking if Anlage has Indirekteinleiter"));
                }
            }
        }
    }, [values, touchedValues, setValues, confirm, fetchHasIndirekteinleiter, props.betriebstyp.id]);

    useEffect(() => {
        if (hasIndirekteinleiter) {
            confirm({
                title: "Anlage stilllegen",
                description: "Beim Stilllegen der Anlage werden alle angeschlossenen Abwasseranlagen ebenfalls stillgelegt!",
                onClose: () => {
                    values.anlagenstatus = {
                        id: "IN_BETRIEB",
                        value: "in Betrieb",
                    };
                    setValues(values);
                }
            });
        }
    }, [hasIndirekteinleiter, confirm, setValues, values]);

    useEffect(() => {
        if (stammdatenAntragLoader.data) {
            setStammdatenantrag(stammdatenAntragLoader.data);
            if (stammdatenAntragParam) {
                setDlgApproveChangeOpen(true);
            }
        }
    }, [setStammdatenantrag, stammdatenAntragParam, stammdatenAntragLoader.data]);

    useEffect(() => {
        if (userHasAnyRole([SYSTEMADMIN, FACHADMIN, ZUST_SBD, BETREIBER, BEAUFTRAGTER])) {
            props.setToggleAllowed(true);
        } else {
            props.setToggleAllowed(false);
        }
    }, [values, props]);

    const handleStammdatenChange = (antrag) => {
        setSaveActionLoading(true);
        logger.debug("Antrag wird gesendet", antrag);

        async function uploadData() {
            try {
                switch (values.anlagentyp.id) {
                    case ABWASSERBEHANDLUNG:
                        await postAbwasserbehandlungAenderungsantrag(antrag, values.id);
                        setSaveActionLoading(false);
                        break;
                    case ENTLASTUNG:
                        await postEntlastungAenderungsantrag(antrag, values.id);
                        setSaveActionLoading(false);
                        break;
                    case KUEHLWASSER:
                        await postKuehlwasserAenderungsantrag(antrag, values.id);
                        setSaveActionLoading(false);
                        break;
                    default:
                        return null;
                }
                toast.success("Änderungsantrag erfolgreich eingereicht.");
                setDlgRequestChangeOpen(false);
                setStammdatenantrag({foerderungen: []});
            } catch (e) {
                logger.error("Error uploading anlagestammdaten", e);
                if (e && e.response && e.response.status === 409) {
                    toast.error("Es existiert bereits ein Änderungsantrag. Bitte warten Sie auf dessen Bearbeitung.");
                    setDlgRequestChangeOpen(false);
                    setStammdatenantrag({foerderungen: []});
                } else if (e && e.response && e.response.status === 400 && e.response.data.validationErrors) {
                    const errorMessage = Object.values(e.response.data.validationErrors)[0];
                    toast.warn("Validierung fehlgeschlagen: " + errorMessage);
                    setStammdatenErrors(e.response.data.validationErrors || null);
                } else {
                    toast.error("Es gab einen unbekannten Fehler beim Einreichen des Änderungsantrags.");
                }
            }
            setSaveActionLoading(false);
        }

        uploadData();
    };

    const prepareForUpload = (auditInfo = null) => {
        const anlage = _.cloneDeep(values);

        anlage.betrieb = props.betriebsId;
        anlage.anlagenstatus = anlage.anlagenstatus.id;

        if (anlage.anlagenart && anlage.anlagenart.id) {
            anlage.anlagenart = anlage.anlagenart.id;
        }

        if (anlage.indirekteinleiter || anlage.anlagentyp.id === ENTLASTUNG) {
            if (anlage.aufnahme && anlage.aufnahme.id) {
                anlage.aufnahme = anlage.aufnahme.id;
            }
        } else {
            anlage.aufnahme = null;
        }

        if (anlage.anlagentyp.id === ENTLASTUNG) {
            anlage.indirekteinleiter = false;

            if (anlage.drosselablauf && anlage.drosselablauf.id) {
                anlage.drosselablauf = anlage.drosselablauf.id;
            }
        }

        if ((props.betriebstyp.id === KOMMUNAL || props.betriebstyp.id === AUSSERHALB_RLP) && anlage.indirekteinleiter) {
            delete anlage.entsorgungsraum;
        }

        if (anlage.planungen && anlage.planungen.length > 0) {
            anlage.planungen = anlage.planungen.map((planung) => {
                const objectToReturn = {...planung};
                if (objectToReturn.anschlussKA && objectToReturn.anschlussKA.id) {
                    objectToReturn.anschlussKA = objectToReturn.anschlussKA.id;
                } else {
                    objectToReturn.anschlussKA = null;
                }
                return objectToReturn;
            });
        }

        anlage.zustaendigeBearbeiter = anlage.zustaendigeBearbeiter.map((zust) => {
            return {
                id: !anlageId ? zust.id : null,
                bearbeiter: zust.bearbeiter.datascoutId,
            };
        });

        anlage.zustaendigePersonen = anlage.zustaendigePersonen.map((zust) => {
            return {
                id: zust.id,
                person: zust.person.id,
                zustaendig: zust.zustaendig.map((zustaendigkeit) => zustaendigkeit.id),
            };
        });

        if (anlage.kontakte) {
            anlage.kontakte = anlage.kontakte.map((kontakt) => {
                const objectToReturn = {...kontakt};
                changeFieldValueIfPresent(objectToReturn, "anrede", "id");
                changeFieldValueIfPresent(objectToReturn, "titel", "id");
                return objectToReturn;
            });
        }

        if (anlage.zustaendigePersonen) {
            anlage.zustaendigePersonen = anlage.zustaendigePersonen.map((zustaendigePerson) => {
                const objectToReturn = {...zustaendigePerson};
                if (!anlageId) {
                    objectToReturn.id = null;
                }
                return objectToReturn;
            });
        }

        if (auditInfo) {
            anlage.auditInfo = auditInfo;
        }
        return anlage;
    };

    function getBezeichnungUndFoerderung(approve = false) {
        const itemSize = approve ? 5 : 6;
        return (
            <>
                <Grid item xs={itemSize}>
                    {formFactory.renderInput("bezeichnung", "bezeichnungRO", "Bezeichnung", "text", true)}
                </Grid>
                <Grid item xs={itemSize}>
                    {innerFormFactory.renderInput("bezeichnung", "bezeichnung", "Bezeichnung")}
                </Grid>
                {approve && <Grid item>{innerFormFactory.renderCheckbox("approveBezeichnung", "approveBezeichnung", "Übernehmen")}</Grid>}
                <Grid item xs={itemSize}>
                    <Foerdermassnahmen
                        formFactory={formFactory}
                        data={values.foerderungen}
                        errors={errors}
                        onChange={() => {
                        }}
                        anlegen={false}
                        modus={"l"}
                    />
                </Grid>
                <Grid item xs={itemSize}>
                    <Foerdermassnahmen
                        formFactory={innerFormFactory}
                        data={stammdatenantrag?.foerderungen}
                        errors={stammdatenErrors}
                        onChange={(name, data) => {
                            const valuesToSet = {...stammdatenantrag};
                            _.set(valuesToSet, name, data);
                            setStammdatenantrag(valuesToSet);
                            setStammdatenErrors(innerValidateDirectly(valuesToSet));
                        }}
                        anlegen={true}
                        modus={"s"}
                    />
                </Grid>
                {approve && <Grid item>{innerFormFactory.renderCheckbox("approveFoerderungen", "approveFoerderungen", "Übernehmen")}</Grid>}
            </>
        );
    }

    function getKommentar(approve = false) {
        return (
            <Grid item xs={approve ? 10 : 12}>
                {innerFormFactory.renderInput("kommentar", "kommentar", "Kommentar", "text", approve, {
                    multiline: true,
                    className: "w-100",
                })}
            </Grid>
        );
    }

    function buildRequestChangeBody(approve = false) {
        const itemSize = approve ? 5 : 6;

        if (!values || !values.anlagentyp || !values.anlagentyp.id) return null;
        switch (values.anlagentyp.id) {
            case ABWASSERBEHANDLUNG:
                return (
                    <>
                        {getBezeichnungUndFoerderung(approve)}
                        {getKommentar(approve)}
                    </>
                );
            case ENTLASTUNG:
                return (
                    <>
                        {getBezeichnungUndFoerderung(approve)}
                        <Grid item xs={itemSize}>
                            {formFactory.renderCheckbox("tegAbschluss", "tegAbschlussRO", "TEG Abschluss", true)}
                        </Grid>
                        <Grid item xs={itemSize}>
                            {innerFormFactory.renderCheckbox("tegAbschluss", "tegAbschluss", "TEG Abschluss", false, {
                                forId: "tegAbschlussInDialog",
                            })}
                        </Grid>
                        {approve && (
                            <Grid item>{innerFormFactory.renderCheckbox("approveTegAbschluss", "approveTegAbschluss", "Übernehmen")}</Grid>
                        )}
                        <Grid item xs={itemSize}>
                            {formFactory.renderCheckbox("aufKAGelaende", "aufKAGelaendeRO", "Auf KA-Gelände", true)}
                        </Grid>
                        <Grid item xs={itemSize}>
                            {innerFormFactory.renderCheckbox("aufKAGelaende", "aufKAGelaende", "Auf KA-Gelände", false, {
                                forId: "aufKAGelaendeInDialog",
                            })}
                        </Grid>
                        {approve && (
                            <Grid item>
                                {innerFormFactory.renderCheckbox("approveAufKAGelaende", "approveAufKAGelaende", "Übernehmen")}
                            </Grid>
                        )}
                        {getKommentar(approve)}
                    </>
                );
            case KUEHLWASSER:
                return (
                    <>
                        {getBezeichnungUndFoerderung(approve)}
                        <Grid item xs={itemSize}>
                            {formFactory.renderAutocompleteWerteliste(
                                "kuehlart",
                                "kuehlart",
                                "Art der Kühlung",
                                kuehlartOptionen,
                                false,
                                true
                            )}
                        </Grid>
                        <Grid item xs={itemSize}>
                            {innerFormFactory.renderAutocompleteWerteliste(
                                "kuehlart",
                                "kuehlart",
                                "Art der Kühlung",
                                kuehlartOptionen,
                                false,
                                false
                            )}
                        </Grid>
                        {approve && <Grid item>{innerFormFactory.renderCheckbox("approveKuehlart", "approveKuehlart", "Übernehmen")}</Grid>}
                        <Grid item xs={itemSize}>
                            {formFactory.renderCheckbox("kuehlBehandlung", "kuehlBehandlungRO", "Behandlung des Kühlwassers", true)}
                        </Grid>
                        <Grid item xs={itemSize}>
                            {innerFormFactory.renderCheckbox("kuehlBehandlung", "kuehlBehandlung", "Behandlung des Kühlwassers", false, {
                                forId: "kuehlBehandlungInDialog",
                            })}
                        </Grid>
                        {approve && (
                            <Grid item>
                                {innerFormFactory.renderCheckbox("approveKuehlBehandlung", "approveKuehlBehandlung", "Übernehmen")}
                            </Grid>
                        )}
                        {getKommentar(approve)}
                    </>
                );
            default:
                return null;
        }
    }

    function getRequestChangeContent(approve = false) {
        return (
            <div className={"w-100"}>
                <Grid container spacing={1}>
                    {buildRequestChangeBody(approve)}
                </Grid>
            </div>
        );
    }

    function handleClickRequestChangeOpen() {
        setDlgRequestChangeOpen(true);
    }

    function handleRequestChangeClose() {
        setDlgRequestChangeOpen(false);
    }

    function handleRequestChangeCloseOk() {
        const aenderung = {};
        aenderung.bezeichnung = stammdatenantrag.bezeichnung;
        aenderung.foerderungen = stammdatenantrag.foerderungen;
        aenderung.kommentar = stammdatenantrag.kommentar;
        switch (values.anlagentyp.id) {
            case ENTLASTUNG:
                aenderung.tegAbschluss = stammdatenantrag.tegAbschluss;
                aenderung.aufKAGelaende = stammdatenantrag.aufKAGelaende;
                break;
            case KUEHLWASSER:
                aenderung.kuehlart = stammdatenantrag.kuehlart;
                aenderung.kuehlBehandlung = stammdatenantrag.kuehlBehandlung;
                break;
            default:
                break;
        }

        handleStammdatenChange(aenderung);
    }

    function handleClickApproveChangeOpen() {
        setDlgApproveChangeOpen(true);
    }

    function handleApproveChangeCloseCancel() {
        toast.info("Daten wurden abgelehnt und der Antrag gelöscht");
        setDlgApproveChangeOpen(false);
        setStammdatenantrag({foerderungen: []});
        deleteAnlageAenderungsantrag(values.id)
            .then(() => reFetchStammdatenAntrag())
            .catch((rejection) => console.log("Request got rejected: " + rejection));
    }

    function handleApproveChangeCloseOk() {
        const valuesToChange = {...values};
        if (stammdatenantrag.approveBezeichnung) {
            valuesToChange.bezeichnung = stammdatenantrag.bezeichnung;
        }
        if (stammdatenantrag.approveFoerderungen) {
            valuesToChange.foerderungen = stammdatenantrag.foerderungen;
        }
        if (stammdatenantrag.approveTegAbschluss) {
            valuesToChange.tegAbschluss = stammdatenantrag.tegAbschluss;
        }
        if (stammdatenantrag.approveAufKAGelaende) {
            valuesToChange.aufKAGelaende = stammdatenantrag.aufKAGelaende;
        }
        if (stammdatenantrag.approveKuehlart) {
            valuesToChange.kuehlart = stammdatenantrag.kuehlart;
        }
        if (stammdatenantrag.approveKuehlBehandlung) {
            valuesToChange.kuehlBehandlung = stammdatenantrag.kuehlBehandlung;
        }

        setValues(valuesToChange);
        deleteAnlageAenderungsantrag(values.id)
            .then(() => reFetchStammdatenAntrag())
            .catch((rejection) => console.log("Request got rejected: " + rejection));
        toast.info("Daten wurden übernommen und der Antrag gelöscht");
        setDlgApproveChangeOpen(false);
        setStammdatenantrag(null);
    }

    function toLeseModus(savedAnlage, anlagenId) {
        props.history.replace(calculateAnlagenLink(savedAnlage, anlagenId));
        setSaveActionLoading(false);
    }

    function calculateAnlagenLink(anlage, anlagenId, modus = "modus=l") {
        let pfad = `${routes.BETRIEBSAKTE_RAW}/${anlage.betrieb.id}`;
        if (anlage?.aufnahme) {
            if (anlage?.anlagentyp?.id === ENTLASTUNG) {
                pfad = `${pfad}/${anlage?.anlagentyp?.id?.toLowerCase()}`;
            }
        }
        pfad = `${pfad}/${anlagenId}/anlagendaten?${modus}`;
        return pfad;
    }

    const save = async () => {
        const e = validate();
        if (e && Object.keys(e).length > 0) {
            return;
        }
        setSaveActionLoading(true);
        const objectToSave = prepareForUpload();
        logger.debug("Save ", objectToSave);
        let savedAnlage = null;
        try {
            switch (objectToSave.anlagentyp.id) {
                case ABWASSERBEHANDLUNG:
                    savedAnlage = await putAbwasserbehandlung(objectToSave);
                    break;
                case ENTLASTUNG:
                    savedAnlage = await putEntlastung(objectToSave);
                    break;
                case KANALNETZ:
                    savedAnlage = await putKanalnetz(objectToSave);
                    break;
                case KUEHLWASSER:
                    savedAnlage = await putKuehlwasser(objectToSave);
                    break;
                default:
                    break;
            }
            toast.success("Anlage erfolgreich gespeichert");
            toLeseModus(savedAnlage.data, savedAnlage?.data?.id);
        } catch (ex) {
            setSaveActionLoading(false);
            const response = ex?.response;
            if (!response) {
                return;
            }
            let newErrors = null;
            if (response?.data?.validationErrors) {
                const errorMessage = Object.values(response.data.validationErrors)[0];
                toast.warn("Validierung fehlgeschlagen: " + errorMessage);
                newErrors = ex.response.data.validationErrors;
            }
            if (response?.data?.possibleSuppressorFlag === "neueAufnahme") {
                setStilllegenDialogOpen(true);
                if (newErrors) {
                    newErrors = {
                        ...newErrors,
                        anlagenstatus: "Die aufnehmende Kläranlage muss erst ersetzt werden!",
                    };
                } else {
                    newErrors = {anlagenstatus: "Die aufnehmende Kläranlage muss erst ersetzt werden!"};
                }
            }
            setErrors(newErrors);
            if (response?.data?.auditInfoViolation) {
                requestAuditInfo(response?.data);
            } else if (!newErrors) {
                handleApiException(ex);
            }
        }
        if (anlageId) {
            refetchHistoryData();
        }
    };

    const saveAsAdmin = async (auditInfo = null) => {
        const e = validate();

        if (e && Object.keys(e).length > 0) {
            return;
        }
        setSaveActionLoading(true);
        const objectToSave = prepareForUpload(auditInfo);
        logger.debug("SaveAsAdmin", objectToSave);
        let savedAnlage = null;
        try {
            if (!objectToSave.id) {
                switch (objectToSave.anlagentyp.id) {
                    case ABWASSERBEHANDLUNG:
                        savedAnlage = await postAbwasserbehandlung(objectToSave);
                        break;
                    case ENTLASTUNG:
                        savedAnlage = await postEntlastung(objectToSave);
                        break;
                    case KANALNETZ:
                        savedAnlage = await postKanalnetz(objectToSave);
                        break;
                    case KUEHLWASSER:
                        savedAnlage = await postKuehlwasser(objectToSave);
                        break;
                    default:
                        break;
                }
            } else {
                switch (objectToSave.anlagentyp.id) {
                    case ABWASSERBEHANDLUNG:
                        savedAnlage = await putAbwasserbehandlung(objectToSave);
                        break;
                    case ENTLASTUNG:
                        savedAnlage = await putEntlastung(objectToSave);
                        break;
                    case KANALNETZ:
                        savedAnlage = await putKanalnetz(objectToSave);
                        break;
                    case KUEHLWASSER:
                        savedAnlage = await putKuehlwasser(objectToSave);
                        break;
                    default:
                        break;
                }
            }
            toast.success("Anlage erfolgreich gespeichert");
            if (touchedValues.bezeichnung || touchedValues.anlagenstatus) {
                props.reloadNavigation();
            }
            toLeseModus(savedAnlage.data, savedAnlage?.data?.id);
        } catch (ex) {
            setSaveActionLoading(false);
            const response = ex?.response;
            if (!response) {
                return;
            }
            let newErrors = null;
            if (response?.data?.validationErrors) {
                const errorMessage = Object.values(response.data.validationErrors)[0];
                toast.warn("Validierung fehlgeschlagen: " + errorMessage);
                newErrors = ex.response.data.validationErrors;
            }
            if (response?.data?.possibleSuppressorFlag === "neueAufnahme") {
                setStilllegenDialogOpen(true);
                if (newErrors) {
                    newErrors = {
                        ...newErrors,
                        anlagenstatus: "Die aufnehmende Kläranlage muss erst ersetzt werden!",
                    };
                } else {
                    newErrors = {anlagenstatus: "Die aufnehmende Kläranlage muss erst ersetzt werden!"};
                }
            }
            setErrors(newErrors);
            if (response?.data?.auditInfoViolation) {
                requestAuditInfo(response?.data);
            } else if (!newErrors) {
                handleApiException(ex);
            }
        }
        if (anlageId) {
            refetchHistoryData();
        }
    };

    const requestAuditInfo = (violation) => {
        setAuditInfoDialogOpen(true);
        setAuditInfoDialogViolation(violation);
    };

    const renderButtonBar = () => {
        return (
            <EAButtonBar
                style={{
                    marginTop: "var(--buttonBar-spacing-top)",
                    marginBottom: "10px",
                    marginRight: "10px",
                    marginLeft: "10px",
                }}
            >
                {anlageId && values?.anlagentyp?.id !== KANALNETZ && props.modus === "l" && (
                    <div style={{flex: "max-content"}}>
                        <EAHistorySelector
                            data={historyData}
                            loading={historyLoading}
                            additionalColumns={[
                                createColumn("bezeichnung", "Bezeichnung", {padding: "2px"}),
                                createCalculatedColumn(
                                    "anlagenstatus",
                                    (row) => {
                                        return row.anlagenstatus.value;
                                    },
                                    "Status",
                                    {padding: "2px"}
                                ),
                            ]}
                            onClickSelect={(row) => {
                                if (props.modus === "s")
                                    props.history.push(props.location.pathname + _.replace(props.location.search, "modus=s", "modus=l"));
                                if (row.timestamp !== "aktuell") setValues({...row, history: true});
                                else setValues({...row});
                            }}
                            onCancel={() => setValues({...currentVersion})}
                        />
                    </div>
                )}
                {values &&
                    values.anlagentyp &&
                    userHasAnyRole([BETREIBER, BEAUFTRAGTER]) &&
                    values.anlagentyp.id !== KANALNETZ &&
                    values.anlagentyp.id !== ENTLASTUNG &&
                    anlageId &&
                    formFactory.renderButton(
                        "aenderungsantragEinreichen",
                        "aenderungsantragEinreichen",
                        "Änderungsantrag erstellen",
                        () => handleClickRequestChangeOpen(),
                        {
                            "data-cy": "aenderungsantragEinreichen",
                        }
                    )}
                {userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]) &&
                    anlageId &&
                    stammdatenAntragLoader.data &&
                    Object.keys(stammdatenAntragLoader.data).length > 0 &&
                    formFactory.renderButton(
                        "aenderungsantragPruefen",
                        "aenderungsantragPruefen",
                        "Antrag prüfen",
                        () => handleClickApproveChangeOpen(),
                        {
                            "data-cy": "aenderungsantragPruefen",
                            color: "primary",
                        }
                    )}
                {userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]) &&
                    !anlageId &&
                    formFactory.renderButton("cancelCreate", "cancelCreate", "Abbrechen", () => props.history.goBack())}
                {userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]) &&
                    formFactory.renderButton(
                        "saveAnlageAsAdmin",
                        "saveAnlageAsAdmin",
                        "Speichern",
                        (e) => {
                            e.preventDefault();
                            saveAsAdmin();
                        },
                        {
                            "data-cy": "saveZustSbd",
                            color: "primary",
                            disabled: loadingHasIndirekteinleiter,
                            loading: loadingHasIndirekteinleiter,
                        }
                    )}
                {userHasAnyRole([BETREIBER, BEAUFTRAGTER]) &&
                    formFactory.renderButton("saveAnlage", "saveAnlage", "Speichern", save, {
                        color: "primary",
                    })}
            </EAButtonBar>
        );
    };

    const buildTabs = () => {
        const options = [tabAnlage];
        const exactAnlagenTyp = values && values.anlagentyp && values.anlagentyp.id ? values.anlagentyp.id : "";
        switch (exactAnlagenTyp) {
            case ABWASSERBEHANDLUNG:
                options.push(tabAuslegung);
                options.push(tabAnlagenteile);
                if (
                    values.anlagenart &&
                    (
                        (props.betriebstyp.id === KOMMUNAL && values.anlagenart.id === ABWASSERBEHANDLUNG) ||
                        (props.betriebstyp.id === AUSSERHALB_RLP && values.anlagenart.id === ANLAGE_AUSSERHALB)
                    ) &&
                    !values.indirekteinleiter
                )
                    options.push(tabEntsorgungsraum);
                break;
            case KUEHLWASSER:
            case ENTLASTUNG:
                options.push(tabAuslegung);
                options.push(tabAnlagenteile);
                break;
            default:
                break;
        }
        options.push(tabZustaendigkeiten);
        return options;
    };

    const getTabErrors = () => {
        const tabErrors = {};
        if (errors && Object.keys(errors).length > 0)
            for (const error in errors) {
                if (!errors.hasOwnProperty(error)) continue;
                if (error.startsWith("entsorgungsraeume")) {
                    if (Object.keys(errors[error]).length > 0) tabErrors[tabEntsorgungsraum] = true;
                } else if (
                    error.startsWith("auslegungUndBelastungsDaten") ||
                    error.startsWith("planungen") ||
                    error.startsWith("foerderungen")
                ) {
                    if (Object.keys(errors[error]).length > 0) tabErrors[tabAuslegung] = true;
                } else if (error.startsWith("bauwerke")) {
                    if (Object.keys(errors[error]).length > 0) tabErrors[tabAnlagenteile] = true;
                } else if (
                    error.startsWith("zustaendigePersonen") ||
                    error.startsWith("zustaendigeBearbeiter") ||
                    error.startsWith("kontakte")
                ) {
                    tabErrors[tabZustaendigkeiten] = true;
                } else {
                    tabErrors[tabAnlage] = true;
                }
            }
        return tabErrors;
    };

    if ((anlageId && anlageLoading) ||
        (!anlageId && (!values.anlagentyp || (props.match.params.parentanlageid && parentAnlageLoader.loading) || betriebLoader.loading)) ||
        saveActionLoading ||
        stammdatenAntragLoader.loading) {
        return (
            <div style={{display: "flex", justifyContent: "center", alignItems: "center",}}>
                <CircularProgress/>
            </div>
        );
    }

    const datenTabOnChangeHandler = (name, data) => {
        const valuesToSet = {...values};
        _.set(valuesToSet, name, data);
        setValues(valuesToSet);
        const touchedValuesToSet = {...touchedValues};
        _.set(touchedValuesToSet, name, true);
        setTouchedValues(touchedValuesToSet);
        setErrors(validateProperty(name, data));
    };

    function getAnlageDatenTab() {
        const exactAnlagenTyp = values && values.anlagentyp && values.anlagentyp.id ? values.anlagentyp.id : "";
        switch (exactAnlagenTyp) {
            case ABWASSERBEHANDLUNG:
                return (
                    <Abwasserbehandlung
                        data={{...values}}
                        setValues={setValues}
                        errors={errors}
                        formFactory={formFactory}
                        anlageId={anlageId}
                        modus={props.modus}
                        onChange={datenTabOnChangeHandler}
                        {...props}
                    />
                );
            case KUEHLWASSER:
                return (
                    <Kuehlwasser
                        data={{...values}}
                        errors={errors}
                        formFactory={formFactory}
                        modus={props.modus}
                        anlageId={anlageId}
                        onChange={datenTabOnChangeHandler}
                        {...props}
                    />
                );
            case ENTLASTUNG:
                return (
                    <Entlastung
                        data={{...values}}
                        errors={errors}
                        formFactory={formFactory}
                        modus={props.modus}
                        anlageId={anlageId}
                        onChange={datenTabOnChangeHandler}
                        {...props}
                    />
                );
            case KANALNETZ:
                return (
                    <Kanalnetz
                        data={{...values}}
                        errors={errors}
                        formFactory={formFactory}
                        modus={props.modus}
                        anlageId={anlageId}
                        onChange={datenTabOnChangeHandler}
                        {...props}
                    />
                );
            default:
                return <div></div>;
        }
    }

    const datenContainerOnChangeHandler = (name, data) => {
        const valuesToSet = {...values};
        _.set(valuesToSet, name, data);
        setValues(valuesToSet);
        setErrors(validateProperty(name, data));
    };

    const backgroundColor = values && values.history ? {background: "#FFFFFF", filter: "sepia()"} : {};
    return (
        <EABetriebsakteMainContainer style={backgroundColor}>
            <EADialog
                open={dlgRequestChangeOpen}
                titleChildren={"Änderungsantrag erstellen (Anlagedaten)"}
                content={getRequestChangeContent(false)}
                buttons={
                    <React.Fragment>
                        <EAButton
                            id={"eins"}
                            data-cy={"btnRequestChangeAbbrechen"}
                            label={"Abbrechen"}
                            onClick={handleRequestChangeClose}
                        />
                        <EAButton
                            id={"ok"}
                            data-cy={"btnRequestChangeOk"}
                            label={"Übernehmen"}
                            color="primary"
                            onClick={handleRequestChangeCloseOk}
                        />
                    </React.Fragment>
                }
            />
            <EADialog
                open={dlgApproveChangeOpen}
                titleChildren={"Änderungsantrag prüfen (Anlagedaten)"}
                content={getRequestChangeContent(true)}
                buttons={
                    <React.Fragment>
                        <EAButton
                            id={"antragReject"}
                            data-cy={"btnApproveChangeReject"}
                            label={"Ablehnen"}
                            onClick={handleApproveChangeCloseCancel}
                        />
                        <EAButton
                            id={"antragApprove"}
                            data-cy={"btnApproveChangeApprove"}
                            label={"Übernehmen"}
                            color="primary"
                            onClick={handleApproveChangeCloseOk}
                        />
                    </React.Fragment>
                }
            />
            {stilllegenDialogOpen && (
                <StilllegenDialog
                    open={stilllegenDialogOpen}
                    anlage={{...values, value: values.bezeichnung}}
                    onCancel={() => {
                        const objectToSet = {...values};
                        delete objectToSet.neueAufnahme;
                        setValues(objectToSet);
                        setStilllegenDialogOpen(false);
                    }}
                    onOk={(anlagen) => {
                        const objectToSet = {...values};
                        objectToSet.neueAufnahme = anlagen[0].aufnahme.id;
                        objectToSet.angeschlosseneAnlage = anlagen[0].aufnahme;
                        setValues(objectToSet);
                        setStilllegenDialogOpen(false);
                        setErrors(null);
                    }}
                />
            )}
            {auditInfoDialogOpen && (
                <AuditInfoDialog
                    open={auditInfoDialogOpen}
                    onClose={() => setAuditInfoDialogOpen(false)}
                    violation={auditInfoDialogViolation}
                    onAuditInfoSet={(aud) => saveAsAdmin(aud)}
                    onVerwerfen={() => {
                        setAuditInfoDialogOpen(false);
                        refetch().catch((e) => handleApiException(e, "Error on AuditInfoDialog.onVerwerfen"));
                    }}
                />
            )}
            <EATabs
                value={selectedTab}
                onChange={(newSelectedTab) => setSelectedTab(newSelectedTab)}
                options={buildTabs()}
                errors={getTabErrors()}
            />
            <EABetriebsakteDatenContainer>
                {selectedTab === tabAnlage && getAnlageDatenTab()}
                {selectedTab === tabAuslegung && (
                    <AuslegungenPlanungFoerdermassnahmen
                        data={values}
                        errors={errors}
                        formFactory={formFactory}
                        onChange={datenContainerOnChangeHandler}
                        betriebId={props.betriebsId}
                        anlagentyp={props.anlagenart}
                        {...props}
                    />
                )}
                {selectedTab === tabAnlagenteile && (
                    <Bauwerke
                        data={values.bauwerke}
                        parentId={anlageId}
                        errors={errors}
                        formFactory={formFactory}
                        modus={props.modus}
                        onChange={datenContainerOnChangeHandler}
                        {...props}
                    />
                )}
                {selectedTab === tabEntsorgungsraum && (
                    <Entsorgungsraum
                        entsorgungsraeume={values.entsorgungsraeume ? values.entsorgungsraeume : []}
                        formFactory={formFactory}
                        modus={props.modus}
                        parentId={anlageId}
                        onTeilentsorgungsraeumeUpdate={(newEntsorgungsRaeume) => {
                            const valuesToSet = {...values};
                            _.set(valuesToSet, "entsorgungsraeume", newEntsorgungsRaeume);
                            const touchedValuesToSet = {...touchedValues};
                            _.set(touchedValuesToSet, "entsorgungsraeume", true);
                            setValues(valuesToSet);
                            setTouchedValues(touchedValuesToSet);
                        }}
                    />
                )}
                {selectedTab === tabZustaendigkeiten && (
                    <Zustaendigkeiten
                        data={values}
                        parentId={anlageId}
                        betriebsId={props.betriebsId}
                        errors={errors}
                        formFactory={formFactory}
                        onChange={datenContainerOnChangeHandler}
                        {...props}
                    />
                )}
            </EABetriebsakteDatenContainer>
            {renderButtonBar()}
        </EABetriebsakteMainContainer>
    );
}

export default AnlagenDatenView;
